import { useQuery } from 'react-query';
import OrganisationSpace from '../../../store/types/organisation-space';
import { useApiService } from '../api-service-provider';

export const getAllTenantSpacesQueryKey = (organizationId: string) =>
  ['all-tenant-spaces', organizationId];

const useAllSpaces = (organizationId: string) => {
  const apiService = useApiService();

  return useQuery(
    getAllTenantSpacesQueryKey(organizationId), // Same as the paginated spaces
    () =>
      apiService.get<OrganisationSpace[]>('/api/spaces', {
        organizationId,
      }),
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
    },
  );
};

export default useAllSpaces;
